import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { captureTracking } from "./utils/leadTracking";
import LandingPage from "./pages/LandingPage";
import EmergenzaMeteoPage from "./pages/EmergenzaMeteoPage";
import GrandinePage from "./pages/GrandinePage";
import LavorazioniPage from "./pages/LavorazioniPage";
import PartnerPage from "./pages/PartnerPage";
import ThankYouPage from "./pages/ThankYouPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import ClausolePage from "./pages/ClausolePage";
import CollaborazioniPage from "./pages/CollaborazioniPage";
import { Toaster } from "./components/ui/sonner";
import CookieBanner from "./components/CookieBanner";

function App() {
  useEffect(() => { captureTracking(); }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/emergenza-meteo" element={<EmergenzaMeteoPage />} />
          <Route path="/grandine" element={<GrandinePage />} />
          <Route path="/lavorazioni" element={<LavorazioniPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/grazie" element={<ThankYouPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/clausole" element={<ClausolePage />} />
          <Route path="/collaborazioni" element={<CollaborazioniPage />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
      <Toaster />
    </div>
  );
}

export default App;
